import React, { useState, useEffect } from "react";
import global from "../../global-variables";
import Header from "../layout/header";
import { Link } from "react-router-dom";
import $ from "jquery";
import WOW from "wowjs";
import { FaLink, FaImage, FaRegFilePdf, FaVideo, FaChevronRight } from "react-icons/fa";

import { Container, Row, Col } from "reactstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Metatag from "../../hooks/Metatag";
import { HashLink } from "react-router-hash-link";


export default function GESHIITBLLP() {
  const [show, setShow] = useState(false);
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const [expanded, setExpanded] = useState(false);

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -134;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  }

  useEffect(() => {
    $(window).on("scroll", function () {
      $(".navbar").offset().top > 10 ? $(".fixed-top").removeClass("bg-header-home") : $(".fixed-top").removeClass("bg-header-home")
    });

    // initiate the wow effect
    new WOW.WOW({
      live: false,
    }).init();


  }, []);


  return (
    <>
      <Header></Header>

      <Metatag title='GESH IITB Living Lab Program'
        description='GESH IITB Living Lab Program'
        keywords='GESH IITB Living Lab Program'
      />

      {/* Visual Panel */}
      <Container fluid className="bg-visual-inside px-0" >
        <div className="visual-inside-big visual-container-inside">
          <Container >
            <Row className="g-md-0 rounded-4">
              <Col md={12}>
                <div className="py-md-4">
                  <div className="m-0 text-center py-xl-3 p-2 text-white">
                    <h1 className="fw-light text-white m-0 align-self-center wow fadeInUp">
                      GESH IITB Living Lab Program
                    </h1>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>

      {/* Container */}
      <Container className="my-5 pt-4 pt-xl-5">
        <Row className="g-0">

          <div className="border rounded-4 p-xl-5 p-3 h-100">
            <Col md={12} lg={11} className="m-auto">
              <Row>
                <Col md={12} className="text-center m-auto">
                  <p>The GESH IITB Living Lab Program transforms IIT Bombay into a dynamic hub for sustainability innovation, leveraging the campus as a testbed for real-world solutions. By integrating research, collaboration, and hands-on experimentation, the program drives impactful initiatives that align with IITB’s sustainability goals. The Living Lab Program envisions to place IIT Bombay as a model campus for sustainability and innovation. We aim to create scalable solutions that extend beyond IITB, setting a precedent for campuses across the world.</p>
                  <img src={global.variables.strDomainUrl + "images/geshiitb-llp.png"} alt="" title="" className="img-fluid wow fadeInUp" />
                </Col>
              </Row>
            </Col>
          </div>
        </Row>
      </Container>

      <Container className="my-5">
        <Row className="g-0">
          <div className="border rounded-4 p-xl-5 p-3 h-100">
            <Col className="m-auto">
              <Row>
                <Col md={12}>
                  <div className="mb-5">
                    <h5 className="mb-3 text-md-center">Currently there are four initiatives under the GESH IITB Living Lab Program:</h5>
                    {/* <div className="d-flex flex-wrap justify-content-md-center gap-3 mb-5 d-md-block d-none">
                      <div><HashLink to="#GESHIITBCourses" className="btn btn-outline-primary rounded-pill px-md-4" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>GESH IITB Course</HashLink></div>
                      <div><HashLink to="#GESHLivingLabFellowship" className="btn btn-outline-primary rounded-pill px-md-4" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>GESH Living Lab Fellowship</HashLink></div>
                      <div><HashLink to="#10GreatIdeas" className="btn btn-outline-primary rounded-pill px-md-4" onClick={() => setExpanded(false)} scroll={el => scrollWithOffset(el)}>10 Great Ideas for a Sustainable Campus</HashLink></div>
                      <div><HashLink to="#MVPPilot" className="btn btn-outline-primary rounded-pill px-md-4">MVP Pilot demonstrations at IITB Campus</HashLink></div>
                    </div> */}
                    <div className="d-flex flex-wrap justify-content-md-center gap-md-4 gap-2 mb-5">
                      <div className="d-flex align-items-center gap-2"><div className="numcircle bg-primary">1</div> GESH IITB Course</div>
                      <div className="d-flex align-items-center gap-2"><div className="numcircle bg-primary">2</div> GESH IITB Living Lab Fellowship</div>
                      <div className="d-flex align-items-center gap-2"><div className="numcircle bg-primary">3</div> 10 Great Ideas for a Sustainable Campus</div>
                      <div className="d-flex align-items-center gap-2"><div className="numcircle bg-primary">4</div> MVP Pilot demonstrations at IITB Campus</div>
                    </div>
                  </div>

                  <hr className="my-5 p-0 d-md-block d-none" />
                  <Row className="row-cols-1 g-xl-5 g-4">
                    <Col>
                      <Row className="g-0">
                        <Col md={8} lg={8} className="pe-lg-5 pe-md-4">
                          <h4 className="mb-3 wow fadeInUp">GESH IITB Course : Sustainability - Theory to Action</h4>
                          <p className="wow fadeInUp">GESH IITB, as a part of the living lab program, is off ering a <b>6-credit course SOM694</b> under SJM School of Management (SOM). It is a 6-credit course being off ered as an institute elective and started in January 2025. Taking sustainability out of the classroom and into action, the course focuses on experiential learning- through case studies, hands-on activities, and expert masterclasses. Students will gain real-world skills in sustainability, project management, and change leadership. This isn’t just a course – it’s a journey to make working on sustainability fun, practical, and impactful.</p>
                        </Col>
                        <Col md={4} lg={4}>
                          <img src={global.variables.strDomainUrl + "images/geshiitb-course.jpg"} alt="" title="" className="img-fluid rounded-3 w-100 wow fadeInUp" />
                        </Col>
                      </Row>
                    </Col>
                    <hr />
                    <Col>
                      <Row className="g-0">
                        <Col md={8} lg={8} className="ps-lg-5 pe-md-4 order-lg-2">
                          <h4 className="mb-3 wow fadeInUp">GESH IITB Living Lab Fellowship</h4>
                          <p className="wow fadeInUp">The GESH IITB Living Lab Fellowship is a unique opportunity for students to work on pre-vetted sustainability projects within the IITB ecosystem. This initiative not only drives meaningful change on campus but also equips students with the skills to become sustainability leaders.</p>

                          <b className="wow fadeInUp">How do we apply?</b>
                          <p className="wow fadeInUp">The 2026–2027 applications are now open. <br className="d-md-block d-none" /> <a href="https://gesh.iitb.ac.in/event-details/gesh-iitb-living-lab-fellowship-cohort-iii" target="_blank" rel="noopener noreferrer" className=" wow fadeInUp">Click here to know more</a></p>
                        </Col>
                        <Col md={4} lg={4} className="order-lg-1">
                          <img src={global.variables.strDomainUrl + "images/geshiitb-llf.png"} alt="" title="" className="img-fluid rounded-3 w-100 wow fadeInUp" />
                        </Col>
                      </Row>
                    </Col>
                    <hr />
                    <Col>
                      <Row className="g-0">
                        <Col md={8} lg={8} className="pe-lg-5 pe-md-4">
                          <h4 className="mb-3 wow fadeInUp">10 Great Ideas for a Sustainable Campus</h4>
                          <p className="wow fadeInUp">Sustainability starts at home, and at GESH IITB, we believe our campus is the perfect place to turn ideas into action. Addressing today’s environmental challenges requires collective effort, and we invite the entire IITB community-students, faculty, and staff - to contribute. Whether it’s through innovative ideas, research, or hands-on implementation, your involvement can shape a greener, more sustainable IIT Bombay.</p>
                          <p className="wow fadeInUp">GESH IITB invited the entire IITB Community to <b>‘be a part of the change’</b> by submitting their ideas to the ‘10 Great Ideas for Campus Sustainability’ initiative. We received an overwhelming response of which several ideas have been selected to be taken forward by GESH IITB
                           Fellows.</p>
                        </Col>
                        <Col md={4} lg={4}>
                          <img src={global.variables.strDomainUrl + "images/greatideas.jpg"} alt="" title="" className="img-fluid rounded-3 w-100 wow fadeInUp" />
                        </Col>
                      </Row>
                    </Col>
                    {/* <hr />
                    <Col id="MVPPilot">
                      <Row className="g-0">
                        <Col md={8} lg={8} className="pe-lg-5 pe-md-4 order-lg-2">
                          <h4 className="mb-3 wow fadeInUp">MVP Pilot demonstrations at IITB Campus</h4>
                        </Col>
                        
                        
                      </Row>
                    </Col> */}
                  </Row>
                </Col>
              </Row>
            </Col>
          </div>
        </Row>
      </Container>
      {/* Breadcrumb */}
      <Breadcrumb className="breadcrumb-panel mt-auto">
        <Breadcrumb.Item href={global.variables.strDomainUrl}>Home</Breadcrumb.Item>
        <Breadcrumb.Item active>Campus Sustainability</Breadcrumb.Item>
        <Breadcrumb.Item active>GESH IITB Living Lab Program</Breadcrumb.Item>
        <Breadcrumb.Item active>Initiatives</Breadcrumb.Item>
      </Breadcrumb>
    </>
  );
}